export const getTitle = (location: string) => {
  switch (location) {
    case '/':
      return '«onlinePBX» - Главная'
    // case '/new-year':
    //   return '«onlinePBX» - Звонок Дедушке Морозу'
    case '/features':
      return '«onlinePBX» — Возможности'
    case '/partners':
      return '«onlinePBX» — Партнерам'
    case '/help':
      return '«onlinePBX» — Помощь'
    case '/price':
      return '«onlinePBX» — Цена'
    case '/docs':
      return '«onlinePBX» — Документы'
    case '/about':
      return '«onlinePBX» — О компании'
    case '/stories':
      return '«onlinePBX» — Кейсы'
    case '/contacts':
      return '«onlinePBX» — Контакты'
    case '/404':
      return '«onlinePBX» — Такой страницы не существует'
    case '/404/phoner':
      return '«onlinePBX» — Такой страницы не существует'
    case '/features/calls':
      return '«onlinePBX» — Управление звонками'
    case '/features/integrations':
      return '«onlinePBX» — Интеграции'
    case '/features/storage':
      return '«onlinePBX» — Хранение звонков'
    case '/features/statistics':
      return '«onlinePBX» — Статистика и дашборд'
    case '/features/callback':
      return '«onlinePBX» — Callback-виджет'
    case '/features/calls':
      return '«onlinePBX» — Мобильное приложение'
    case '/features/notifications':
      return '«onlinePBX» — Уведомления'
    case '/features/api':
      return '«onlinePBX» — API & webhooks'
    case '/features/auto_recall':
      return '«onlinePBX» — Автоперезвон на пропущенные звонки'
    case '/features/auto_informer':
      return '«onlinePBX» — Автоинформатор'
    case '/features/quality_score':
      return '«onlinePBX» — Оценка качества'
    case '/stories/max_dance':
      return '«onlinePBX» — Школа танцев'
    case '/stories/barbershop':
      return '«onlinePBX» — Барбершоп'
    case '/stories/energy_fit':
      return '«onlinePBX» — Фитнес-клуб'
    case '/stories/igrolandia':
      return '«onlinePBX» — Игроландия'
    case '/stories/online_school':
      return '«onlinePBX» — Онлайн-школа'
    default:
      return ''
  }
}
